<template>
  <div class="app-header">
    <div class="app-header-left" @click="goToHome">
      <div class="app-header-logo">
        <!-- <svg-icon icon-class="logo" class="logo-svg"></svg-icon> -->
        <img  style="width:120px;height:40px;" src="../../../assets/images/daoyuan_logo.png" alt />
      </div>
      <!-- <div class="app-header-logo log-margin">
        <svg-icon icon-class="logo" class="logo-svg"></svg-icon>
      </div>-->
      <span class="app-header-title log-margin">{{ $t("title.headerTitle") }}</span>
    </div>
    <el-popover
      placement="bottom"
      trigger="hover"
      popper-class="scim-common-theme  scim-common-theme-green"
      class="cursor-p float-right"
      style="margin-right: 16px"
      :visible-arrow="false"
    >
      <div slot="reference" style="line-height: 56px">
        <svg-icon icon-class="lang" style="font-size: 24px; margin-right: 8px; margin-top: 16px"></svg-icon>
      </div>
      <div class="self-popover-items" style="min-width: 100px">
        <p
          class="self-popover-item"
          :class="{ active: lang === 'zh' }"
          @click="handleChangeLang('zh')"
        >
          中文
        </p>
        <p
          class="self-popover-item"
          :class="{ active: lang === 'en' }"
          @click="handleChangeLang('en')"
        >
          English
        </p>
      </div>
    </el-popover>
  </div>
</template>

<script>
import { getLang } from "@/utils/auth";
export default {
  name: "LogoHead",
  filters: {
    langFilter(val) {
      switch (val) {
        case "zh":
          return "中文";
        case "en":
          return "English";
      }
    }
  },
  data() {
    return {
      lang: getLang()
    };
  },
  watch: {
    lang: {
      handler(val) {
        this.$store.commit("settings/CHANGE_LANG", val);
      },
      immediate: true
    }
  },
  methods: {
    goToHome() {
      this.$router.push({ path: "/login" });
    },
    handleChangeLang(lang) {
      this.$store.dispatch("loading/setFullLoading", true);
      this.lang = lang;
      location.reload();
    }
  }
};
</script>

<style lang="scss" scoped>
.log-margin {
  margin-left: 16px;
}
$weightText: #21252e;
$themeGreen: #00b259;
.app-header {
  width: 100%;
  height: 56px;
  box-sizing: border-box;
  overflow: hidden;
  position: fixed;
  z-index: 12;
  background: #f5f7fa;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  .app-header-left {
    height: 100%;
    float: left;
    display: flex;
    padding-left: 20px;

    .app-header-logo {
      display: flex;
      align-items: center;
      margin-right: 6px;
      width: 136px;
      height: 100%;
      .logo-svg {
        width: 100%;
        height: 20px;
      }
    }
    .app-header-title {
      line-height: 52px;
      font-size: 18px;
      font-weight: 600;
      color: $weightText;
      user-select: none;
      -moz-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
    }
  }
}
</style>
